import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var LanguageIcon = function LanguageIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "LanguageIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M5.8 1c.406 0 .736.33.736.736v.788h.279a.736.736 0 0 1 0 1.472h-.297c-.095 1.665-.557 3.188-1.284 4.352a7 7 0 0 1-.132.203c.738.33 1.685.549 2.747.575a.736.736 0 1 1-.037 1.472c-1.408-.035-2.712-.361-3.726-.906-.67.56-1.464.906-2.35.906a.736.736 0 0 1 0-1.472c.372 0 .752-.116 1.12-.353-.51-.539-.841-1.2-.84-1.96a.736.736 0 1 1 1.472.003c0 .278.119.591.398.904l.099-.152c.567-.909.965-2.155 1.057-3.572H1.736a.736.736 0 0 1 0-1.472h3.327v-.788c0-.406.33-.736.736-.736m5.755 6.433c.29 0 .555.171.673.437l2.708 6.094a.736.736 0 1 1-1.346.598l-.859-1.932h-2.353l-.859 1.932a.736.736 0 0 1-1.346-.598l.957-2.152a.73.73 0 0 1 .18-.407l1.572-3.535a.74.74 0 0 1 .673-.437m-.522 3.724h1.044l-.522-1.175z",
      clipRule: "evenodd"
    })
  }));
};

export { LanguageIcon };
